import mdi from '@/icons/mdi';
import ph from '@/icons/ph';

export default {
    mdi,
    ph
};
